function onlyNumbers(value) {
  if (!value) {
    return null;
  }
  return value.match(/\d+/g).join('');
}

function hasAnyLetter(text) {
  return text.match(/[a-zA-Z]/g);
}

function formatCnpj(cnpj) {
  if (!cnpj) {
    return '';
  }
  if (cnpj.match(/\d+/g)) {
    return cnpj.match(/\d+/g).join('');
  }
  return cnpj;
}
export {
  formatCnpj,
  onlyNumbers,
  hasAnyLetter,
};
